module.exports = __webpack_public_path__ + "img/icons8-golang.8d6f2b20.svg";